export function loadTranslations({ baseUrl, translationsName, language, httpClient }) {
  const url = baseUrl + translationsName + '_' + language + '.json';

  return httpClient.get(url).then(res => res.data);
}
